const initialState = {
	userData: null,
};

const ProfileReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'UPDATE_USER_DATA':
			return Object.assign({}, state, {
				userData: action.userData
			});
		default:
			return state
	}
}

export default ProfileReducer;